// extracted by mini-css-extract-plugin
export default {"wrapper":"gU-z","availablePromoMessagesLabel":"hU-z","promoMessageList":"iU-z","promoMessage":"jU-z","appliedPromoMessage":"kU-z","promoMessageAmount":"lU-z"};